<div class="preloader" [hidden]='!display'>
  <div class="status">
    <div class="spinner-border avatar-sm m-2" role="status"></div>
    @if (text) {
      <div class="loading-text">{{ text }}</div>
    }
  </div>
</div>